<div class="row">
    <div class="col-md-12 text-center">
        <div>
            <app-form-button *ngIf="vm.cancelText !== ''"
                [title]="vm.cancelText" outline="true" 
                (clicked)="cancel()" size="sm"
                [disabled]="vm.workingText ? true : false"
                color="danger" rounded="true">
            </app-form-button>
            <app-form-button [title]="vm.workingText || vm.okText" outline="true"
                [disabled]="vm.workingText || !vm.isValid"
                [color]="!vm.isValid ? 'warning' : 'success'"
                (clicked)="ok()" size="sm"
                rounded="true">
            </app-form-button>
        </div>
        <div *ngIf="vm.errorText">
            <span class="text-danger">{{vm.errorText}}</span>
        </div>
    </div>
</div>
